import {connect} from "react-redux";
import InspectionList from "./InspectionList";
import {bindActionCreators} from "redux";
import {accountDetails, getFilter, getCityByStateId,
    getInspectionListing} from "../../../service/Account/action";

const mapStateToProps = (state) => ({
    accountList:state.Dropdown.accountDetails,
    accountFilterContent:state.Dropdown.accountFilterContent,
    geoCity:state.Dropdown.geoCity,
    inspectionList:state.Dropdown.inspectionList
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            accountDetails,
            getFilter,
            getCityByStateId,
            getInspectionListing
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(InspectionList);
